export default __webpack_public_path__ + "static/media/relative-mono-10-pitch-pro.4341f7db.woff";